// const PATH_PREFIX = process.env.REACT_APP_PATH_PREFIX;
const PATH_PREFIX = '';
export const Routing = {
    JSONViewer1:`/`,
    JSONViewer: `/json-formatter`,
    XMLFormattor:`/xml-formatter`
};
